export default {
    dangerIndications: [],
    dangerIndicationsHtml: ""
};
